module.exports = __webpack_public_path__ + "img/service-icon2.6df12e4a.png";